import { useContext } from "react";

import { UploadCentreContext } from "../context/UploadCentreContext";

export default function useUploadCentreContext() {
  const uploadCentre = useContext(UploadCentreContext);

  return uploadCentre;
}
